import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { target: String }

  syncHumor() {
    document.getElementById(this.targetValue).value = ['funny', 'informal', 'professional'][this.element.value]
  }
}
